import styled from "@emotion/styled";
import React from "react";
import { Hash } from "viem";
import { ActivityStore } from "../../store/activity/ActivityStore";
import { TokenHistoryInfo } from "../../types/history";
import { Chain } from "viem/chains";

export enum Direction {
  Vertical,
  Horizontal,
}

interface TokenStackedArrayProps {
  direction: Direction;
  tokenHistory: TokenHistoryInfo;
  tokenSize: number;
  chainId: Chain["id"];
}

export const TokenStackedArray = React.memo(
  ({ direction, tokenHistory, tokenSize, chainId }: TokenStackedArrayProps) => {
    const history = ActivityStore.useState(s => s.history.data);
    const historyMetadata = ActivityStore.useState(s => s.historyMetadata);
    const tokenAddresses = Object.keys(tokenHistory);
    if (history && tokenAddresses.length > 0) {
      return (
        <Container size={tokenSize} tokenLength={tokenAddresses.length} direction={direction}>
          {tokenAddresses.map((tokenAddress, index) => {
            return (
              <TokenIcon
                src={historyMetadata[chainId][tokenAddress as Hash]?.icon}
                tokenIndex={index}
                tokenCount={tokenAddresses.length}
                direction={direction}
                size={tokenSize}
                alt={tokenAddress}
                key={tokenAddress}
              />
            );
          })}
        </Container>
      );
    }
    return null;
  }
);

// Sub-components

const Container = styled.div<{ size: number; tokenLength: number; direction: Direction }>`
  position: relative;
  width: ${props =>
    props.direction === Direction.Horizontal
      ? props.size + GAP_BETWEEN_ICON_HORIZONTAL * (props.tokenLength - 1)
      : props.size}px;
  height: ${props =>
    props.direction === Direction.Horizontal
      ? props.size
      : props.size + GAP_BETWEEN_ICON_VERTICAL * (props.tokenLength - 1)}px;
`;

export const TokenIcon = styled.img<{
  tokenIndex: number;
  tokenCount: number;
  size: number;
  direction: Direction;
}>(props => ({
  position: props.tokenIndex === 0 ? "relative" : "absolute",
  top:
    props.direction === Direction.Vertical
      ? `${GAP_BETWEEN_ICON_VERTICAL * props.tokenIndex}px`
      : "0",
  left:
    props.direction === Direction.Horizontal
      ? `${GAP_BETWEEN_ICON_HORIZONTAL * props.tokenIndex}px`
      : "0",
  zIndex: `${10 - props.tokenIndex}`,
  width: `${props.size}px`,
  height: `${props.size}px`,
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
}));

// Helpers

const GAP_BETWEEN_ICON_VERTICAL = 5;
const GAP_BETWEEN_ICON_HORIZONTAL = 18;
